import { Star, Phone } from "lucide-react";

const MapSearchCard = ({ place, onSelect, isActive, distanceUnit = 'mi' }) => {

  return (
    <button
      onClick={() => onSelect(place)}
      className={`
        w-full text-left p-3 rounded-lg transition-all duration-200
        ${isActive 
          ? 'bg-primary/10 border-2 border-primary shadow-sm' 
          : 'bg-white border border-border hover:bg-muted/50'
        }
      `}
    >
      <h3 className={`
        font-medium text-sm mb-1 line-clamp-1
        ${isActive ? 'text-primary' : 'text-foreground'}
      `}>
        {place.name}
      </h3>
      
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        {place.rating && (
          <div className="flex items-center gap-0.5">
            <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
            <span>{place.rating}</span>
          </div>
        )}
        <span>·</span>
        <span>{place.distance ? (distanceUnit === 'km' ? `${(place.distance * 1.60934).toFixed(1)} km` : `${place.distance.toFixed(1)} mi`) : ''}</span>
      </div>

      {place.phone && (
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground mt-1">
          <Phone className="w-3 h-3" />
          <span>{place.phone}</span>
        </div>
      )}
    </button>
  );
};

export default MapSearchCard;
